import { StakingPoolTable } from '../../staking/features/view-staking-pools';

export const StakingList = () => {
  return <StakingPoolTable />;
};
